import moment from 'moment';
import { STOCK_RECONCILIATION_DASH } from 'entities/StockReconciliation/StockReconciliation.const';

export const formatStockReconciliationNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined) {return STOCK_RECONCILIATION_DASH;}
  if (Number.isNaN(value)) {return STOCK_RECONCILIATION_DASH;}
  return (Math.round(value * 100) / 100).toString();
};

export const formatStockReconciliationPercent = (value: number | null | undefined): string => {
  if (value === null || value === undefined || Number.isNaN(value)) {return STOCK_RECONCILIATION_DASH;}
  return `${(Math.round(value * 100) / 100).toString()}%`;
};

export const formatStockReconciliationTime = (value: string | null | undefined): string => {
  if (!value) {return STOCK_RECONCILIATION_DASH;}
  const m = moment(value);
  return m.isValid() ? m.format('HH:mm') : STOCK_RECONCILIATION_DASH;
};

export const formatStockReconciliationDay = (value: string): string => {
  const m = moment(value);
  return m.isValid() ? m.format('ddd, MMM D') : value;
};

export const stockReconciliationWeekOptions = (): { value: string; label: string }[] => {
  const options: { value: string; label: string }[] = [
    { value: 'currentWeek', label: 'Current Week' },
    { value: 'lastWeek', label: 'Last Week' },
  ];
  const currentIsoWeek = moment().isoWeek();
  const currentIsoYear = moment().isoWeekYear();

  for (let i = 1; i <= 8; i++) {
    const m = moment().subtract(i, 'weeks');
    const wk = m.isoWeek();
    const yr = m.isoWeekYear();
    if (wk === currentIsoWeek && yr === currentIsoYear) {continue;}

    const weekStart = m.clone().startOf('isoWeek');
    const weekEnd = m.clone().endOf('isoWeek');
    const value = `${yr}-W${String(wk).padStart(2, '0')}`;
    const label = `Week ${wk} (${weekStart.format('MMM D')} - ${weekEnd.format('MMM D')})`;
    options.push({ value, label });
  }

  return options;
};
